import React, { useState } from 'react'
import PostManagement from '../components/PostManagement/PostManagement'

const PagePostManagement = () => {
  return (
    <>
      <PostManagement></PostManagement>
    </>
  )
}

export default PagePostManagement
